import React, { useState, useContext } from "react"
import { Mutation } from "react-apollo"
import CREATE_FAVORITES_FILE from "../../graphql/createFavoritesFile.graphql"
import TextField from "../TextField"
import Button from "../Button"
import FolderSelect from "../../views/MyFavorites/components/FolderSelect"
import { useForm } from "./hooks"
import { MESSAGE_TYPE } from "./const"
import { ButtonGroup, FormGroup } from "./displays"
import { ModalMessage } from "../Modal"
import AppContext from "../../shared/AppContext"

export default function MarketPlaceForm(props) {
  const { favoriteData, refetch, productQuery, trackingLocation } = props
  const { trackEvent } = useContext(AppContext)

  const [values, setValues] = useForm({
    name: props.favoriteData.name || "",
    description: props.favoriteData.description || "",
  })
  const [folderName, setFolderName] = useState("")
  const [folderId, setFolderId] = useState("")

  const [message, setMessage] = useState({ type: "", text: "" })

  const handleAddFavorite = (mutation) => {
    if (!values.name.trim()) {
      return setMessage({
        type: MESSAGE_TYPE.REQUIRED,
        text: "Name is required",
      })
    }

    mutation({
      variables: {
        name: values.name,
        favoriteType: favoriteData.favoriteType,
        slug: favoriteData.slug,
        metadata: favoriteData.metadata,
        folderId: folderId,
        description: values.description,
      },
      update: (cache, { data: { createFavoritesFile } }) => {
        if (!productQuery) {
          return
        }

        const favorite = createFavoritesFile
        const data = cache.readQuery(productQuery)
        let products = data.products.map((product) => {
          if (product && product.id === favorite.product.id) {
            return {
              ...product,
              isMyFavorite: { ...product.isMyFavorite, id: favorite.id },
            }
          }
          return product
        })

        cache.writeQuery({
          ...productQuery,
          data: {
            ...data,
            products,
          },
        })
      },
    })
      .then(({ data }) => {
        const { createFavoritesFile } = data

        if (createFavoritesFile.response) {
          setMessage({
            type: createFavoritesFile.response.payload,
            text: createFavoritesFile.response.message,
          })
        }
        if (createFavoritesFile.response.payload === MESSAGE_TYPE.SUCCESS) {
          trackEvent("Added Favorite", {
            name: values.name,
            metadata: favoriteData.metadata,
            favoriteType: favoriteData.favoriteType,
            location: trackingLocation,
          })
        }

        refetch && refetch()
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text:
            "Oh no! Something went wrong. Please go to https://app.etr.ai/help to get support.",
        })
        console.log("Marketplace form Error", err)
      })
  }

  if (MESSAGE_TYPE.SUCCESS === message.type) {
    return (
      <ModalMessage
        messageType={MESSAGE_TYPE.SUCCESS}
        text={message.text}
        closeModal={props.setIsModalOpen}
      />
    )
  }

  return (
    <Mutation mutation={CREATE_FAVORITES_FILE}>
      {(mutation) => {
        return (
          <div>
            <FormGroup>
              <TextField
                placeholder="Favorite Name"
                name="name"
                label={"Name"}
                errors={message.type == MESSAGE_TYPE.REQUIRED}
                errorOptions={{
                  outline: true,
                  showMessage: true,
                  message: message.text,
                  hasError: message.type == MESSAGE_TYPE.REQUIRED,
                }}
                fullWidth={true}
                value={values.name}
                onChange={(e) => setValues(e)}
                dataCy="input-favorite-name"
              />
            </FormGroup>
            <FormGroup>
              <label>
                Folder Name <i>(optional)</i>
              </label>
              <FolderSelect
                folderName={folderName}
                folderId={folderId}
                setFolderName={setFolderName}
                setFolderId={setFolderId}
              />
            </FormGroup>
            <FormGroup>
              <label>
                Description <i>(optional)</i>
              </label>
              <TextField
                placeholder="Key in your description"
                name="description"
                fullWidth={true}
                value={values.description}
                onChange={(e) => setValues(e)}
              />
            </FormGroup>
            {(message.type == MESSAGE_TYPE.SAVE_ERROR ||
              message.type == MESSAGE_TYPE.ALREADY_EXIST) && (
              <ModalMessage
                messageType={MESSAGE_TYPE.SAVE_ERROR}
                text={message.text}
                style={{ textAlign: "right" }}
              />
            )}

            <ButtonGroup>
              <Button
                classes={["btn-cancel"]}
                style={{ marginRight: "1rem" }}
                action={props.setIsModalOpen}
              >
                Cancel
              </Button>
              <Button
                classes={["btn-primary"]}
                action={() => handleAddFavorite(mutation)}
                data-cy="add-favorite-form-submit"
              >
                Add To Favorites
              </Button>
            </ButtonGroup>
          </div>
        )
      }}
    </Mutation>
  )
}
